enum PhoneNumberType {
    LOCAL = 'local',
    TOLL_FREE = 'toll-free',
    TEN_DLC = '10DLC'
}

enum Provider {
    BANDWIDTH = 'bandwidth',
    TWILIO = 'twilio'
}


enum Status {
    AVAILABLE = 'Available',
    OWNED = 'Owned'
}


export enum AppCode {
    HS = 'HS',
    CNXN = 'CNXN'
    // ADHOC = 'ADHOC',
    // DEMO = 'DEMO'
}


export interface PhoneNumber {
    phoneNumber: string;
    type: PhoneNumberType;
    vanity: string|null;
    provider: Provider;
    status: Status;
    appCode: null|AppCode;
}
